import { FC } from 'react'
import { PoiDescription } from './poi/PoiDescription.tsx'
import { GeometryListing } from './poi/GeometryListing.tsx'
import { PoiActions } from './poi/PoiActions.tsx'
// @ts-ignore
import { DirectGeometryObject, Feature } from 'geojson'
import { PoiTags } from './poi/PoiTags.tsx'
import { useAtomValue } from 'jotai'
import { effectiveActivePoiAtom } from '@/js/editor/state/poiAtoms.ts'

export const PoiEditor: FC = () => {
    const activePoi = useAtomValue(effectiveActivePoiAtom)

    if (activePoi == null) {
        return (
            <div
                className={
                    'flex-4 min-h-full flex justify-center items-center bg-mm-bg3/60 backdrop-blur-lg saturate-180 min-w-62.5 z-1001'
                }
            >
                <span className={'text-mm-gray2 p-2 text-sm text-center'}>Kein Eintrag ausgewählt</span>
            </div>
        )
    }

    return (
        <div
            className={
                'flex-4 px-5 flex-col min-h-full space-y-4 overflow-y-auto bg-mm-bg3/80 backdrop-blur-lg saturate-180 min-w-62.5 z-1001'
            }
        >
            <div className={'flex pt-3 items-center justify-between'}>
                <span className={'text-xl font-semibold'}>Eigenschaften</span>
                <PoiActions poiToSave={() => activePoi} />
            </div>

            <PoiDescription poi={activePoi} />
            <GeometryListing poi={activePoi} />
            <PoiTags poi={activePoi} />
        </div>
    )
}
